import { GraphQLClient } from 'graphql-request';
import * as Dom from 'graphql-request/dist/types.dom';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AbbrevCanadaProvince: { input: any; output: any; }
  Answers: { input: any; output: any; }
  Byte: { input: string; output: string; }
  CanadaProvince: { input: "Alberta" | "British Columbia" | "Manitoba" | "New Brunswick" | "Newfoundland and Labrador" | "Northwest Territories" | "Nova Scotia" | "Nunavut" | "Ontario" | "Prince Edward Island" | "Quebec" | "Saskatchewan" | "Yukon"; output: "Alberta" | "British Columbia" | "Manitoba" | "New Brunswick" | "Newfoundland and Labrador" | "Northwest Territories" | "Nova Scotia" | "Nunavut" | "Ontario" | "Prince Edward Island" | "Quebec" | "Saskatchewan" | "Yukon"; }
  CanadaTimeZone: { input: any; output: any; }
  ConvertedAnswers: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  ObjectID: { input: string; output: string; }
  PostalCode: { input: string; output: string; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AdditionalInsured = {
  __typename?: 'AdditionalInsured';
  address?: Maybe<AdditionalInsuredAddress>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AdditionalInsuredAddress = {
  __typename?: 'AdditionalInsuredAddress';
  address2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  province: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  region: Scalars['CanadaProvince']['output'];
  street: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  postalCode: Scalars['PostalCode']['input'];
  region: Scalars['CanadaProvince']['input'];
  street: Scalars['String']['input'];
};

export type AnswersInput = {
  answers: Scalars['Answers']['input'];
  applicationId: Scalars['ObjectID']['input'];
  reasonFlag?: InputMaybe<Scalars['String']['input']>;
};

export type AnswersWithIdInput = {
  answers: Scalars['Answers']['input'];
  applicationId: Scalars['ObjectID']['input'];
  isBrokerFlow: Scalars['Boolean']['input'];
  reasonFlag?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationBlocked = {
  __typename?: 'ApplicationBlocked';
  applicationId: Scalars['ObjectID']['output'];
};

export type ApplicationFailure = {
  __typename?: 'ApplicationFailure';
  error: Scalars['String']['output'];
};

export type ApplicationResponse = ApplicationFailure | ApplicationSuccess;

export enum ApplicationResultKind {
  /** This means to decline quote */
  DeclineBusiness = 'DeclineBusiness',
  /** This means error happen */
  Error = 'Error',
  /** This means forward to get a quote */
  OfferQuote = 'OfferQuote',
  /** This means go to broker flow anyway */
  SendToBroker = 'SendToBroker'
}

export type ApplicationSuccess = {
  __typename?: 'ApplicationSuccess';
  applicationId: Scalars['ObjectID']['output'];
};

export type BusinessAddressChange = {
  __typename?: 'BusinessAddressChange';
  newAddress: UnderwritingAddress;
};

/** BUY NOW button popup */
export type BusinessInfo = {
  __typename?: 'BusinessInfo';
  companyName: Scalars['String']['output'];
  coverageStartDate: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  dbaName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export enum CanadaChildCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions */
  Eo = 'EO',
  /** Hardware / Software */
  Hwsw = 'HWSW',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Lock Key Business Items */
  LockKeyBusinessItems = 'LockKeyBusinessItems',
  /** Lock Key Contractors */
  LockKeyContractors = 'LockKeyContractors',
  /** Photo Video Endorsement */
  PhotoVideoEndor = 'PhotoVideoEndor',
  /** Physical Loss */
  PhysicalLoss = 'PhysicalLoss',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft',
  /** Unscheduled Business Personal PropertyP */
  UnscheduledBpp = 'UnscheduledBPP',
  /** Unscheduled Contractors */
  UnscheduledContractors = 'UnscheduledContractors',
  /** Unscheduled hardware/software */
  UnscheduledHwsw = 'UnscheduledHWSW',
  /** Unscheduled Small Tools */
  UnscheduledSmallTools = 'UnscheduledSmallTools',
  /** Valuable Papers */
  ValuablePapers = 'ValuablePapers'
}

export type CanadaCoverageLimit = {
  __typename?: 'CanadaCoverageLimit';
  coverage: CanadaCoverageLimitType;
  newLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
  oldLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

/**
 * This type is mostly a copy of ChildCoverageType. However, it's needed since some child coverage has
 * multiple limits, like E&O which needs to distinguish between occurrence & aggregate limits.
 * Most limit names use the same one as the coverage name since they only have 1 limit.
 */
export enum CanadaCoverageLimitType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions (Aggregate) */
  EoAggregate = 'EOAggregate',
  /** Errors & Omissions (Occurrence) */
  EoOccurrence = 'EOOccurrence',
  /** Hardware / Software */
  Hwsw = 'HWSW',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Lock Key Business Items */
  LockKeyBusinessItems = 'LockKeyBusinessItems',
  /** Lock Key Contractors */
  LockKeyContractors = 'LockKeyContractors',
  /** Photo Video Endorsement */
  PhotoVideoEndor = 'PhotoVideoEndor',
  /** Physical Loss */
  PhysicalLoss = 'PhysicalLoss',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft',
  /** Unscheduled Business Personal PropertyP */
  UnscheduledBpp = 'UnscheduledBPP',
  /** Unscheduled Contractors */
  UnscheduledContractors = 'UnscheduledContractors',
  /** Unscheduled hardware/software */
  UnscheduledHwsw = 'UnscheduledHWSW',
  /** Unscheduled Small Tools */
  UnscheduledSmallTools = 'UnscheduledSmallTools',
  /** Valuable Papers */
  ValuablePapers = 'ValuablePapers'
}

export type CanadaCoverageUpdateChange = {
  __typename?: 'CanadaCoverageUpdateChange';
  action: EndorsementCoverageAction;
  coverage: CanadaParentCoverageType;
  limits: Array<CanadaCoverageLimit>;
};

export enum CanadaParentCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Inland Marine */
  Im = 'IM'
}

export enum CancellationTrigger {
  Carrier = 'carrier',
  Client = 'client'
}

/** Update CompletedApplicationResponse types in anther ticket */
export type CompletedApplicationResponse = {
  __typename?: 'CompletedApplicationResponse';
  applicationId?: Maybe<Scalars['ObjectID']['output']>;
  errors: Array<Scalars['String']['output']>;
  kind: ApplicationResultKind;
};

export type CoverageInput = {
  chooseCoverage: Scalars['Boolean']['input'];
  limits: Scalars['JSONObject']['input'];
  name: Scalars['String']['input'];
};

export type CoveragesData = {
  __typename?: 'CoveragesData';
  chooseCoverage: Scalars['Boolean']['output'];
  finalPremium: Scalars['Int']['output'];
  limits: Scalars['JSONObject']['output'];
  limitsOptions?: Maybe<Scalars['JSONObject']['output']>;
  name: Scalars['String']['output'];
  retroactiveDate?: Maybe<Scalars['String']['output']>;
};

/** Currencies that are supported by Foxden. */
export enum Currency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type CustomerInfoInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type EndorsementChange = BusinessAddressChange | CanadaCoverageUpdateChange | MailingAddressChange | NamedInsuredChange | OhioCoverageUpdateChange;

export enum EndorsementCoverageAction {
  Add = 'Add',
  Remove = 'Remove',
  Update = 'Update'
}

export type FetchQuoteResponse = {
  __typename?: 'FetchQuoteResponse';
  carrierName: Scalars['String']['output'];
  premium: Scalars['Float']['output'];
  quoteId: Scalars['ObjectID']['output'];
  quoteNumber: Scalars['String']['output'];
};

export type GetJsoNbyApplicationIdResponse = {
  __typename?: 'GetJSONbyApplicationIdResponse';
  customerInfo: CustomerInfo;
  json: Scalars['JSONObject']['output'];
  policyExpiryDateStr?: Maybe<Scalars['String']['output']>;
  policyStartDateStr?: Maybe<Scalars['String']['output']>;
  previousAnswers?: Maybe<Scalars['ConvertedAnswers']['output']>;
  professionList: Array<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  wcData?: Maybe<GetJsonWcResponse>;
};

export type GetJsonWcError = {
  __typename?: 'GetJsonWcError';
  message: Scalars['String']['output'];
};

export type GetJsonWcResponse = GetJsonWcError | GetJsonWcSuccess | GetJsonWcUnavailable;

export type GetJsonWcSuccess = {
  __typename?: 'GetJsonWcSuccess';
  classCodes: Array<WcProfession>;
  isContractor: Scalars['Boolean']['output'];
  rules: Array<Rule>;
};

/** You should expect an empty object with __typename; GraphQL doesn't allow empty object so I need to define something */
export type GetJsonWcUnavailable = {
  __typename?: 'GetJsonWcUnavailable';
  notUsed?: Maybe<Scalars['Boolean']['output']>;
};

export type GetQuoteDecline = {
  __typename?: 'GetQuoteDecline';
  reason?: Maybe<Scalars['String']['output']>;
};

export type GetQuoteExpired = {
  __typename?: 'GetQuoteExpired';
  country?: Maybe<Scalars['String']['output']>;
  isEffectiveDateExpired?: Maybe<Scalars['Boolean']['output']>;
  isGracePeriodExpired?: Maybe<Scalars['Boolean']['output']>;
  isQuoteExpired?: Maybe<Scalars['Boolean']['output']>;
  quoteExpireDate: Scalars['String']['output'];
  quoteId: Scalars['ObjectID']['output'];
};

export type GetQuoteOk = {
  __typename?: 'GetQuoteOk';
  additionalInsuredInfoList?: Maybe<Array<AdditionalInsured>>;
  carrierPartner: Scalars['String']['output'];
  coveragesData: Array<CoveragesData>;
  disableAdditionalInsuredCheckbox: Scalars['Boolean']['output'];
  /**
   * True when this call created the quote rather than returning an existing one.
   * The quote page uses it to decide whether to trigger the consolidated group
   * email (NCP-5129): a freshly added LOB produces a new quote and so a new
   * email, while a plain page refresh produces neither.
   */
  isNewQuote: Scalars['Boolean']['output'];
  premium: Scalars['Float']['output'];
  quoteExpireDate: Scalars['String']['output'];
  quoteId: Scalars['ObjectID']['output'];
  quoteNumber: Scalars['String']['output'];
  region: Scalars['String']['output'];
  transactionType: Scalars['String']['output'];
};

export type GetRatingResultsResponse = {
  __typename?: 'GetRatingResultsResponse';
  aggregations: Scalars['JSONObject']['output'];
  input: Scalars['JSONObject']['output'];
  /**
   * The rater's own working: every factor it looked up and every intermediate
   * premium, keyed by rating label. This is what makes a premium reviewable
   * against the rating manual rather than only comparable to a number.
   */
  labels: Scalars['JSONObject']['output'];
};

export enum IdType {
  Claim = 'Claim',
  Invoice = 'Invoice',
  Policy = 'Policy',
  Quote = 'Quote',
  Transaction = 'Transaction'
}

export type Limit = {
  __typename?: 'Limit';
  industry: Scalars['String']['output'];
  max: Scalars['NonNegativeInt']['output'];
  min: Scalars['NonNegativeInt']['output'];
};

export type MailingAddressChange = {
  __typename?: 'MailingAddressChange';
  newAddress: UnderwritingAddress;
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelPolicy: Scalars['String']['output'];
  noOp?: Maybe<Scalars['Boolean']['output']>;
  resetCoverageRecommendation: UpdateCoverageOutput;
  /**
   * Send one consolidated Foxden email covering every LOB in the group.
   *
   * Called by the quote page after every getQuote for the group has resolved —
   * the only point where every LOB's quote number exists. Returns false when the
   * group has no quoted LOB, in which case forms-backend already emailed it.
   */
  sendApplicationGroupEmail: Scalars['Boolean']['output'];
  startWc?: Maybe<Scalars['ObjectID']['output']>;
  updateCoverage: UpdateCoverageOutput;
};


export type MutationCancelPolicyArgs = {
  quoteId: Scalars['ObjectID']['input'];
  signMethod?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetCoverageRecommendationArgs = {
  input: ResetCoverageRecommendationInput;
};


export type MutationSendApplicationGroupEmailArgs = {
  applicationGroupId: Scalars['ObjectID']['input'];
};


export type MutationStartWcArgs = {
  applicationObjectId: Scalars['ObjectID']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCoverageArgs = {
  input: UpdateCoverageInput;
};

export type NamedInsuredChange = {
  __typename?: 'NamedInsuredChange';
  namedInsured: Scalars['String']['output'];
};

export enum OhioChildCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL',
  /** Errors & Omissions */
  Eo = 'EO',
  /** Limited Pollution */
  LimitedPollution = 'LimitedPollution',
  /** Terrorism Risk Insurance Act (TRIA) for GL */
  Triagl = 'TRIAGL',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft'
}

export type OhioCoverageLimit = {
  __typename?: 'OhioCoverageLimit';
  coverage: OhioCoverageLimitType;
  newLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
  oldLimit?: Maybe<Scalars['NonNegativeFloat']['output']>;
};

/**
 * This type is mostly a copy of ChildCoverageType. However, it's needed since some child coverage has
 * multiple limits, like E&O which needs to distinguish between occurrence & aggregate limits.
 * Most limit names use the same one as the coverage name since they only have 1 limit.
 */
export enum OhioCoverageLimitType {
  /** Commercial General Liability (Aggregate) */
  CglAggregate = 'CGLAggregate',
  /** Commercial General Liability (Aggregate) */
  CglOccurrence = 'CGLOccurrence',
  /** Miscellaneous Errors & Omissions (Aggregate) */
  EoAggregate = 'EOAggregate',
  /** Miscellaneous Errors & Omissions (Occurrence) */
  EoOccurrence = 'EOOccurrence',
  /** Limited Pollution (Aggregate) */
  LimitedPollutionAggregate = 'LimitedPollutionAggregate',
  /** Limited Pollution (Occurrence) */
  LimitedPollutionOccurrence = 'LimitedPollutionOccurrence',
  /** Terrorism Risk Insurance Act (TRIA) for GL */
  Triagl = 'TRIAGL',
  /** Unmanned Aircraft */
  UnmannedAircraft = 'UnmannedAircraft'
}

export type OhioCoverageUpdateChange = {
  __typename?: 'OhioCoverageUpdateChange';
  action: EndorsementCoverageAction;
  coverage: OhioParentCoverageType;
  limits: Array<OhioCoverageLimit>;
};

export enum OhioParentCoverageType {
  /** Commercial General Liability */
  Cgl = 'CGL'
}

export type PolicyDates = {
  policyEffectiveDate: Scalars['Date']['input'];
  policyExpirationDate: Scalars['Date']['input'];
  transactionEffectiveDate: Scalars['Date']['input'];
  transactionExpirationDate: Scalars['Date']['input'];
};

/**
 * Dates for the LOB being rated. GL uses the per-sub-product `gl`/`im` pair;
 * EO has no sub-products and so uses the flat `eo` set instead (falling back to
 * `gl` when only that is supplied). Every field is nullable so a caller only has
 * to send the ones its `lobType` needs.
 */
export type PolicyDatesForRegionInput = {
  eo?: InputMaybe<PolicyDates>;
  gl?: InputMaybe<PolicyDates>;
  im?: InputMaybe<PolicyDates>;
  region: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  fetchQuoteForCancellation: Array<FetchQuoteResponse>;
  generateConsolidatedQuotePdf: Scalars['Byte']['output'];
  generateQuotePdf: Scalars['Byte']['output'];
  getQuote: QuoteResponse;
  getRatingResults: GetRatingResultsResponse;
  noOp?: Maybe<Scalars['Boolean']['output']>;
  tryGetWcQuestions: TryGetWcQuestionsReponse;
};


export type QueryFetchQuoteForCancellationArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGenerateConsolidatedQuotePdfArgs = {
  quoteIds: Array<Scalars['ObjectID']['input']>;
};


export type QueryGenerateQuotePdfArgs = {
  quoteId: Scalars['ObjectID']['input'];
};


export type QueryGetQuoteArgs = {
  applicationId: Scalars['ObjectID']['input'];
};


export type QueryGetRatingResultsArgs = {
  answers: Scalars['ConvertedAnswers']['input'];
  carrierPartner: Scalars['String']['input'];
  lobType?: InputMaybe<Scalars['String']['input']>;
  multipleLinesDiscountFactor?: InputMaybe<Scalars['Boolean']['input']>;
  policyDatesForRegion: PolicyDatesForRegionInput;
  quoteVersion: Scalars['String']['input'];
};


export type QueryTryGetWcQuestionsArgs = {
  applicationObjectId: Scalars['ObjectID']['input'];
  wcSessionObjectId: Scalars['ObjectID']['input'];
};

export type QuoteResponse = GetQuoteDecline | GetQuoteExpired | GetQuoteOk;

export type ResetCoverageRecommendationInput = {
  applicationId: Scalars['ObjectID']['input'];
  quoteId: Scalars['ObjectID']['input'];
  region: Scalars['String']['input'];
};

export type Rule = {
  __typename?: 'Rule';
  canChooseToIncludeExclude: Scalars['Boolean']['output'];
  isIncludedByDefault: Scalars['Boolean']['output'];
  limits: Array<Limit>;
  note: Scalars['String']['output'];
  officer: Scalars['String']['output'];
};

export type TryGetWcQuestionsReponse = {
  __typename?: 'TryGetWcQuestionsReponse';
  /** True if the quote cannot be binded by our partners. */
  isDecline: Scalars['Boolean']['output'];
  questions: Array<WcQuestion>;
  /** Client has to keep polling if the status is 'NotFound' */
  status: TryGetWcQuestionsStatus;
};

export enum TryGetWcQuestionsStatus {
  Error = 'Error',
  Found = 'Found',
  NotFound = 'NotFound'
}

export type UnderwritingAddress = {
  __typename?: 'UnderwritingAddress';
  city: Scalars['String']['output'];
  postalCode: Scalars['PostalCode']['output'];
  province: Scalars['AbbrevCanadaProvince']['output'];
  street: Scalars['String']['output'];
};

export type UpdateApplicationResponse = ApplicationBlocked | ApplicationFailure | ApplicationSuccess;

export type UpdateCoverageInput = {
  applicationId: Scalars['ObjectID']['input'];
  coverage: CoverageInput;
  quoteId: Scalars['ObjectID']['input'];
  region: Scalars['String']['input'];
};

export type UpdateCoverageOutput = {
  __typename?: 'UpdateCoverageOutput';
  coveragesData: Array<CoveragesData>;
  finalPremium: Scalars['Int']['output'];
  quoteId: Scalars['ObjectID']['output'];
};

/** This is an enum of most of the 2-letter abbreviations of US States. Some states are missing at this time but it's good enough for our purposes. */
export enum UsState {
  Ar = 'AR',
  Az = 'AZ',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Ga = 'GA',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wi = 'WI',
  Wy = 'WY'
}

export type WcProfession = {
  __typename?: 'WcProfession';
  description: Scalars['String']['output'];
  id: WcProfessionId;
};

export type WcProfessionId = {
  __typename?: 'WcProfessionId';
  classCode: Scalars['String']['output'];
  descriptionCode: Scalars['String']['output'];
};

export type WcProfessionIdInput = {
  classCode: Scalars['String']['input'];
  descriptionCode: Scalars['String']['input'];
};

export type WcQuestion = {
  __typename?: 'WcQuestion';
  id: Scalars['NonNegativeInt']['output'];
  question: Scalars['String']['output'];
};

export type CreateApplicationAnswersInput = {
  BusinessInformation_100_BrokerCode_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  BusinessInformation_100_Country_WORLD_EN: Scalars['String']['input'];
  BusinessInformation_100_CustomerInfo_WORLD_EN: CustomerInfoInput;
  BusinessInformation_100_OtherProfessionCheck_WORLD_EN?: InputMaybe<Scalars['Boolean']['input']>;
  BusinessInformation_100_PartnerCode_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  BusinessInformation_100_PrimaryProfession_WORLD_EN: Scalars['String']['input'];
  BusinessInformation_100_ProfessionsPercentage_WORLD_EN?: InputMaybe<Scalars['JSONObject']['input']>;
  BusinessInformation_100_Province_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  BusinessInformation_100_SecondaryProfessionAdditional_WORLD_EN?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  BusinessInformation_100_SecondaryProfessions_WORLD_EN?: InputMaybe<Array<Scalars['String']['input']>>;
  BusinessInformation_100_State_WORLD_EN?: InputMaybe<Scalars['String']['input']>;
  otherProfessionsLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryProfessionLabel: Scalars['String']['input'];
  secondaryProfessionsLabels?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFirstJsonResponse = {
  __typename?: 'getFirstJSONResponse';
  json: Scalars['JSONObject']['output'];
  previousAnswers?: Maybe<Scalars['ConvertedAnswers']['output']>;
};

export type IsEndorsementOrCancellationtResponse = {
  __typename?: 'isEndorsementOrCancellationtResponse';
  applicationId: Scalars['ObjectID']['output'];
  isCancellation: Scalars['String']['output'];
  isEndorsement: Scalars['Boolean']['output'];
};

export type GenerateConsolidatedQuotePdfQueryVariables = Exact<{
  quoteIds: Array<Scalars['ObjectID']['input']> | Scalars['ObjectID']['input'];
}>;


export type GenerateConsolidatedQuotePdfQuery = { __typename?: 'Query', generateConsolidatedQuotePdf: string };

export type GenerateQuotePdfQueryVariables = Exact<{
  quoteId: Scalars['ObjectID']['input'];
}>;


export type GenerateQuotePdfQuery = { __typename?: 'Query', generateQuotePdf: string };

export type GetQuoteQueryVariables = Exact<{
  applicationId: Scalars['ObjectID']['input'];
}>;


export type GetQuoteQuery = { __typename?: 'Query', getQuote: { __typename: 'GetQuoteDecline' } | { __typename: 'GetQuoteExpired', quoteId: string, isQuoteExpired?: boolean | null, isEffectiveDateExpired?: boolean | null, isGracePeriodExpired?: boolean | null, quoteExpireDate: string, country?: string | null } | { __typename: 'GetQuoteOk', quoteId: string, premium: number, quoteNumber: string, region: string, disableAdditionalInsuredCheckbox: boolean, transactionType: string, carrierPartner: string, quoteExpireDate: string, isNewQuote: boolean, coveragesData: Array<{ __typename?: 'CoveragesData', chooseCoverage: boolean, finalPremium: number, limits: any, name: string, limitsOptions?: any | null, retroactiveDate?: string | null }>, additionalInsuredInfoList?: Array<{ __typename?: 'AdditionalInsured', name?: string | null, email?: string | null, address?: { __typename?: 'AdditionalInsuredAddress', street: string, city: string, province: string, postalCode: string, address2?: string | null } | null }> | null } };

export type SendApplicationGroupEmailMutationVariables = Exact<{
  applicationGroupId: Scalars['ObjectID']['input'];
}>;


export type SendApplicationGroupEmailMutation = { __typename?: 'Mutation', sendApplicationGroupEmail: boolean };

export type UpdateCoverageMutationVariables = Exact<{
  input: UpdateCoverageInput;
}>;


export type UpdateCoverageMutation = { __typename?: 'Mutation', updateCoverage: { __typename?: 'UpdateCoverageOutput', finalPremium: number, quoteId: string, coveragesData: Array<{ __typename?: 'CoveragesData', chooseCoverage: boolean, finalPremium: number, limits: any, name: string, limitsOptions?: any | null, retroactiveDate?: string | null }> } };


export const GenerateConsolidatedQuotePdfDocument = gql`
    query generateConsolidatedQuotePdf($quoteIds: [ObjectID!]!) {
  generateConsolidatedQuotePdf(quoteIds: $quoteIds)
}
    `;
export const GenerateQuotePdfDocument = gql`
    query generateQuotePdf($quoteId: ObjectID!) {
  generateQuotePdf(quoteId: $quoteId)
}
    `;
export const GetQuoteDocument = gql`
    query getQuote($applicationId: ObjectID!) {
  getQuote(applicationId: $applicationId) {
    ... on GetQuoteOk {
      __typename
      quoteId
      premium
      quoteNumber
      region
      disableAdditionalInsuredCheckbox
      transactionType
      carrierPartner
      coveragesData {
        chooseCoverage
        finalPremium
        limits
        name
        limitsOptions
        retroactiveDate
      }
      additionalInsuredInfoList {
        name
        email
        address {
          street
          city
          province
          postalCode
          address2
        }
      }
      quoteExpireDate
      isNewQuote
    }
    ... on GetQuoteDecline {
      __typename
    }
    ... on GetQuoteExpired {
      __typename
      quoteId
      isQuoteExpired
      isEffectiveDateExpired
      isGracePeriodExpired
      quoteExpireDate
      country
    }
  }
}
    `;
export const SendApplicationGroupEmailDocument = gql`
    mutation sendApplicationGroupEmail($applicationGroupId: ObjectID!) {
  sendApplicationGroupEmail(applicationGroupId: $applicationGroupId)
}
    `;
export const UpdateCoverageDocument = gql`
    mutation updateCoverage($input: UpdateCoverageInput!) {
  updateCoverage(input: $input) {
    coveragesData {
      chooseCoverage
      finalPremium
      limits
      name
      limitsOptions
      retroactiveDate
    }
    finalPremium
    quoteId
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    generateConsolidatedQuotePdf(variables: GenerateConsolidatedQuotePdfQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GenerateConsolidatedQuotePdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateConsolidatedQuotePdfQuery>(GenerateConsolidatedQuotePdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateConsolidatedQuotePdf', 'query');
    },
    generateQuotePdf(variables: GenerateQuotePdfQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GenerateQuotePdfQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GenerateQuotePdfQuery>(GenerateQuotePdfDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'generateQuotePdf', 'query');
    },
    getQuote(variables: GetQuoteQueryVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<GetQuoteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetQuoteQuery>(GetQuoteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getQuote', 'query');
    },
    sendApplicationGroupEmail(variables: SendApplicationGroupEmailMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<SendApplicationGroupEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendApplicationGroupEmailMutation>(SendApplicationGroupEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendApplicationGroupEmail', 'mutation');
    },
    updateCoverage(variables: UpdateCoverageMutationVariables, requestHeaders?: Dom.RequestInit["headers"]): Promise<UpdateCoverageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCoverageMutation>(UpdateCoverageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCoverage', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;